import React from 'react'
import { Button, message, Modal, Popover, Table } from 'antd'
import { useAsync } from '@umijs/hooks'
import { generateDownloadLink, getRecommendImagePackage } from '../../utils/api'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import BindDeviceImage from '../../assets/images/how-to-bind-device.png'
import moment from 'moment'



const Box = styled.div`
  > .title {
    font-size: 22px;
    line-height: 22px;
    margin-top: 40px;
    margin-bottom: 18px;
  }
  .card {
    padding: 24px 32px 16px;
    background-color: #fff;
    margin-bottom: 24px;
    > .title {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 28px;
      margin-bottom: 16px;
    }
    .ant-form-item-control-input,
    .ant-input-number {
      width: 468px;
    }
  }
`

//将10位时间戳转化为YYYY-MM-DD  HH:mm格式
export const stampToString = (time: number, format = 'YYYY-MM-DD  HH:mm') => {
  if (time > 0) {
    return moment(time * 1000).format(format)
  } else {
    return ''
  }
}

const BindDevice: React.FC<{}> = () => {
  const { loading: isGettingRecImage, data: recommendImagePackage, run: runGetRecommendImagePackage } = useAsync(
    getRecommendImagePackage,
  )
  const handleGenerateOrRefresh = async (version: string) => {
    try {
      await generateDownloadLink({ version });
      message.success('地址刷新成功');
      // Refresh the data after successful operation
      runGetRecommendImagePackage();
    } catch (error) {
      console.error('操作失败', error);
    }
  };
  return (
    <Box>
      <div className="title">如何刷镜像</div>
      <div className="card">
        <Table
          rowKey="md5"
          columns={[
            {
              title: '派享云镜像包版本',
              dataIndex: 'version',
            },
            {
              title: '镜像包下载地址',
              dataIndex: 'downloadURL',
              render: (link: string, record: any) => (
                link ? (
                  <Popover content="点击下载">
                    <a rel="noopener noreferrer" target="_blank" href={link}>
                      {link}
                    </a>
                    <div style={{ marginTop: '8px', textAlign: 'center' }}>
                      <Button 
                        type="primary" 
                        onClick={() => {
                          const confirmModal = Modal.confirm({
                            title: '确认刷新下载地址',
                            content: '下载地址仅有效期3小时，过期后需重新生成，确认继续？',
                            okText: '确定',
                            cancelText: '取消',
                            onOk: () => handleGenerateOrRefresh(record.version)
                          });
                        }}
                      >
                        点击刷新
                      </Button>
                    </div>
                  </Popover>
        
                ) : (
                  <Button 
                    type="primary"
                    onClick={() => {
                      // 显示确认对话框
                      const confirmModal = Modal.confirm({
                        title: '确认生成下载地址',
                        content: '下载地址仅有效期3小时，过期后需重新生成，确认继续？',
                        okText: '确定',
                        cancelText: '取消',
                        onOk: () => handleGenerateOrRefresh(record.version)
                      });
                    }}
                  >
                    点击生成
                  </Button>
                )
              ),
            },
            {
              title: '过期时间',
              dataIndex: 'imageCosTempLinkExpireTime',
              render: (time: number) => stampToString(time),
            },
            {
              title: 'MD5校验码',
              dataIndex: 'md5',
            },
          ]}
          dataSource={[
            recommendImagePackage || {
              downloadURL: '',
              md5: '',
              version: '',
              imageCosTempLinkExpireTime: 0,
            },
          ]}
          loading={isGettingRecImage}
          pagination={false}
          style={{ marginBottom: 10 }}
          bordered
        />
        <Link to="/help-center/2/10186" target="_blank" rel="noopener noreferrer">
          戳我查看刷镜像教程
        </Link>
      </div>
      <div className="title">如何绑定设备</div>
      <div
        className="card"
        style={{ padding: '48px 96px', paddingRight: '40%' }}
      >
        <img
          src={BindDeviceImage}
          alt="how-to-bind-device"
          style={{ width: '100%' }}
        />
      </div>
    </Box>
  )
}

export default BindDevice
